"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasAccessibleTripleNativeClients = hasAccessibleTripleNativeClients;
exports.closeWindow = closeWindow;
exports.trackScreen = trackScreen;
exports.trackEvent = trackEvent;
exports.viewItem = viewItem;
exports.notifyScraped = notifyScraped;
exports.notifyUnscraped = notifyUnscraped;
exports.subscribeScrapedChangeEvent = subscribeScrapedChangeEvent;
exports.notifyReviewLiked = notifyReviewLiked;
exports.notifyReviewUnliked = notifyReviewUnliked;
exports.notifyReviewDeleted = notifyReviewDeleted;
exports.subscribeLikedChangeEvent = subscribeLikedChangeEvent;
exports.subscribeReviewUpdateEvent = subscribeReviewUpdateEvent;
exports.shareLink = shareLink;
exports.showToast = showToast;

var _eventStream = _interopRequireDefault(require("./event-stream"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sendSotoMessage(message) {
  if (isAndroidAccessible()) {
    try {
      Soto.postMessage(JSON.stringify(message));
    } catch (e) {
      /* do nothing */
    }
  } else if (isiOSAccessible()) {
    window.webkit.messageHandlers.Soto.postMessage(message);
  }
}

function isAndroidAccessible() {
  return typeof Soto !== 'undefined' && Soto !== null;
}

function isiOSAccessible() {
  return typeof window !== 'undefined' && typeof window.webkit !== 'undefined' && window.webkit !== null && window.webkit.messageHandlers && window.webkit.messageHandlers.Soto;
}

function hasAccessibleTripleNativeClients() {
  return !!(isAndroidAccessible() || isiOSAccessible());
}

function closeWindow() {
  sendSotoMessage({
    command: 'close'
  });
}

function trackScreen(name, screenClass) {
  sendSotoMessage({
    command: 'trackScreen',
    name: name,
    screenClass: screenClass
  });
}

function trackEvent(event) {
  sendSotoMessage(_objectSpread({
    command: 'trackEvent'
  }, event));
}

function viewItem(event) {
  sendSotoMessage(_objectSpread({
    command: 'viewItem'
  }, event));
}

function notifyScraped(id) {
  sendSotoMessage({
    command: 'notifyScraped',
    id: id
  });
}

function notifyUnscraped(id) {
  sendSotoMessage({
    command: 'notifyUnscraped',
    id: id
  });
}

if (typeof window !== 'undefined') {
  window.TripleWeb = {
    onScraped: function onScraped(id) {
      return SCRAP_EVENT_STREAM.publish('scrapedChange', {
        id: id,
        scraped: true
      });
    },
    onUnscraped: function onUnscraped(id) {
      return SCRAP_EVENT_STREAM.publish('scrapedChange', {
        id: id,
        scraped: false
      });
    },
    onReviewLikeChanged: function onReviewLikeChanged(id, liked) {
      return REVIEW_EVENT_STREAM.publish('likedChange', {
        id: id,
        liked: liked
      });
    },
    onReviewUpdated: function onReviewUpdated(id) {
      return REVIEW_EVENT_STREAM.publish('reviewUpdate', {
        id: id
      });
    }
  };
}

var SCRAP_EVENT_STREAM = new _eventStream.default();

function subscribeScrapedChangeEvent(cb) {
  SCRAP_EVENT_STREAM.subscribe('scrapedChange', cb);
}

function notifyReviewLiked(id, reviewId) {
  sendSotoMessage({
    command: 'notifyReviewLiked',
    id: id,
    reviewId: reviewId
  });
}

function notifyReviewUnliked(id, reviewId) {
  sendSotoMessage({
    command: 'notifyReviewUnliked',
    id: id,
    reviewId: reviewId
  });
}

function notifyReviewDeleted(id, reviewId) {
  sendSotoMessage({
    command: 'notifyReviewDeleted',
    id: id,
    reviewId: reviewId
  });
}

var REVIEW_EVENT_STREAM = new _eventStream.default();

function subscribeLikedChangeEvent(cb) {
  REVIEW_EVENT_STREAM.subscribe('likedChange', cb);
}

function subscribeReviewUpdateEvent(cb) {
  REVIEW_EVENT_STREAM.subscribe('reviewUpdate', cb);
}

function shareLink(_ref) {
  var title = _ref.title,
      description = _ref.description,
      link = _ref.link,
      imageUrl = _ref.imageUrl,
      buttons = _ref.buttons,
      method = _ref.method;
  sendSotoMessage({
    command: 'share',
    title: title,
    description: description,
    link: link,
    imageUrl: imageUrl,
    buttons: buttons,
    method: method
  });
}

function showToast(message) {
  sendSotoMessage({
    command: 'showToast',
    message: message
  });
}